// extracted by mini-css-extract-plugin
module.exports = {"spacer":"HeaderSpacer-module--spacer--MiEs9"};